import React, { Component } from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { signoutUser, fetchAuthor } from '../actions';

class Nav extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    this.props.fetchAuthor();
  }

  signInLink = (loggedIn, signout) => {
    if (!loggedIn) {
      return <NavLink id="sign-in" exact to="/signin" className="fake-button">Sign In</NavLink>;
    } else {
      return <button type="button" onClick={signout}>Sign Out</button>;
    }
  };

  profileLink = (loggedIn) => {
    if (!loggedIn) {
      return <div> </div>;
    } else return <NavLink id="my-profile" exact to={`/myprofile/${this.props.author.id}`} className="fake-button"><i className="fas fa-user-circle" /></NavLink>;
  };

  notebookLink = (loggedIn) => {
    if (!loggedIn) {
      return <div> </div>;
    } else return <NavLink id="my-notebook" exact to="/notebook" className="fake-button"><i className="fas fa-book-open" /></NavLink>;
  };

  render() {
    return (
      <>
        <nav>
          <NavLink className="fake-button" exact to="/"><img className="logo" src="https://our-stories.s3.amazonaws.com/logo.png" alt="" /></NavLink>
          <div>
            { this.notebookLink(this.props.loggedIn)}
            { this.profileLink(this.props.loggedIn)}
            { this.signInLink(this.props.loggedIn, () => { this.props.signoutUser(this.props.history); })}
          </div>
        </nav>
      </>
    );
  }
}

const mapStateToProps = (state) => (
  {
    loggedIn: state.auth.authenticated,
    author: state.author.current,
  }
);

export default withRouter(connect(mapStateToProps, { signoutUser, fetchAuthor })(Nav));
